import { loader } from 'graphql.macro'

export default async function addSiteToTicket ({ dataLoaders, variables }) {
  const schema = loader('./addSiteToTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.addSiteToTicket
}
